import { message } from "antd";
import { useState } from "react";

const TokenCheck = () => {
  const [hasSignedOut, setHasSignedOut] = useState(false);

  const signOut = () => {
    if (!hasSignedOut) {
      localStorage.removeItem("USER_ID");
      localStorage.removeItem("USERNAME");
      localStorage.removeItem("TNAME");
      localStorage.removeItem("FNAME");
      localStorage.removeItem("LNAME");
      localStorage.removeItem("NNAME");
      localStorage.removeItem("LICENCE_NO");
      localStorage.removeItem("COMPANY_ID");
      localStorage.removeItem("ROLE_ID");
      localStorage.removeItem("ACTIVE_STATUS");
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("line");
      setHasSignedOut(true);
      message.error("กรุณาเข้า Log In สู่ระบบใหม่");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  };
  return [signOut];
};

export default TokenCheck;
